import { render, staticRenderFns } from "./jobfairUserdetail.vue?vue&type=template&id=48299324&scoped=true"
import script from "./jobfairUserdetail.vue?vue&type=script&lang=js"
export * from "./jobfairUserdetail.vue?vue&type=script&lang=js"
import style0 from "./jobfairUserdetail.vue?vue&type=style&index=0&id=48299324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48299324",
  null
  
)

export default component.exports